module.exports = __webpack_public_path__ + "static/media/logo_chatbot@3x.255d792c.webp";